import React, { ChangeEvent, ReactNode, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { Container, Input, Label, CloseButton } from './uploadField.styles';

export interface UploadFieldProps {
  className?: string;
  name: string;
  accept: string;
  disabled?: boolean;
  handleChange: (url: string) => void;
  children: ReactNode;
}

export const UploadField = ({
  className,
  name,
  accept,
  handleChange,
  children,
  disabled = false,
}: UploadFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const intl = useIntl();
  const closeLabel = intl.formatMessage({ id: 'uploadField.close', defaultMessage: 'Remove image' });
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    const files = inputRef.current?.files;
    if (files && files[0]) {
      setFileName(files[0]?.name);
    }
  }, [inputRef.current?.files]);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0];
    if (file) {
      const image = URL.createObjectURL(file);
      handleChange(image);
    }
  };

  return (
    <Container className={className} disabled={disabled}>
      <Input id={name} name={name} accept={accept} type="file" onChange={onChange} ref={inputRef} disabled={disabled} />
      <Label htmlFor={name} fileName={fileName}>
        {fileName || children}
        {fileName && !disabled && <CloseButton aria-label={closeLabel} />}
      </Label>
    </Container>
  );
};
